import React from 'react';
import { SmallText } from 'ds/components/typography';
import { ColumnRendererProps, BuildingPermitTableColumn } from '../../utils';
import { BuildingPermitColumn } from '../styled';
import { BuildingPermitItem } from 'components/insight-summary-renderer/BuildingPermitSummary/types';
import { ShowAt } from 'consts/breakpoints';
import { useLocale } from 'locale';

export const BuildingPermitLastEventDateColumn: React.FC<ColumnRendererProps<BuildingPermitItem>> = ({ item }) => {
  const { formatDate } = useLocale();

  return (
    <BuildingPermitColumn col={BuildingPermitTableColumn.LastEventDate}>
      <SmallText>
        {formatDate(item.lastEventDate)}
      </SmallText>
      <ShowAt at={1}>
        <SmallText>
          {item.status}
        </SmallText>
      </ShowAt>
    </BuildingPermitColumn>
  );
};
